import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { movementapprovalDto } from '../models/movementapprovalDto';
import { ApiResponseObject } from '../models/responses/api-response-object';

@Injectable({
  providedIn: 'root'
})
export class MovementapprovalService {

  constructor(private httpClient: HttpClient) { }

  getRequestApprovals(requestId:number): Observable<ApiResponseObject<movementapprovalDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<movementapprovalDto[]>>(`${environment.apiUrl}/RequestApprovals/GetByMovementRequestId${requestId}`);
  }
}
